import type { RouterConfig } from '@nuxt/schema'

export default (<RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    const toSegments = to.path.split('/').filter(Boolean)
    const fromSegments = from.path.split('/').filter(Boolean)

    // Переход внутри вложенной секции того же ресурса — не сбрасываем прокрутку.
    if (
      toSegments.length >= 2 &&
      fromSegments.length >= 2 &&
      toSegments[0] === fromSegments[0] &&
      toSegments[1] === fromSegments[1] &&
      // скролли наверх при переходе в деталку дисциплины
      to.name !== 'discipline-detail'
    ) {
      return false
    }

    return { top: 0 }
  },
}) satisfies RouterConfig
